import { ImportAnswrCardPage } from './ImportAnswrCardPage';
export default ImportAnswrCardPage;
